export default __webpack_public_path__ + "static/media/selected-list.a3c14162.svg";